module.exports = __webpack_public_path__ + "media/images/sp/stores/kobe/kobe_concept_02-ed58833ffcee182a7d476c9190607f22.jpg";